<template lang="pug">
  v-container
    v-card
      v-card-title
        v-btn(color="primary" @click="newUser()") {{ $t('words.new') }}
      v-data-table.elevation-1(
          :items="users"
          :headers="headers"
        )
        template( v-slot:items="props" )
          td {{ props.item.displayName }}
          td {{ props.item.email }}
          td {{ props.item.role }}
          td {{ props.item.crm }}
          td {{ props.item.signature ? 'Sim' : '' }}
          td.text-xs-center
            v-menu(offset-y, left)
              template(v-slot:activator="{ on }")
                v-btn.mx-0(v-on="on", @click.stop="" icon='')
                  v-icon(small='')
                    | more_vert
              v-list
                v-list-tile(@click="editUser(props.item)")
                  v-list-tile-title {{ $t('words.edit') | capitalize }}
                v-list-tile(@click="deleteUser(props.item)")
                  v-list-tile-title Excluir
                v-list-tile(
                  v-if="props.item.totpEnabled && isAdmin"
                  @click="removeTOTP(props.item)"
                )
                  v-list-tile-title Remover 2FA
    UserDialog(v-model="dialog", :user="dialogUser")
</template>

<script>
import { mapState, mapActions } from 'vuex'
import UserDialog from './User'
import api from '@/utils/api'

export default {
  name: 'users',

  components: {
    UserDialog
  },

  data () {
    return {
      dialog: false,
      dialogUser: null,
      headers: [
        {text: 'Nome', value: 'displayName'},
        {text: 'Email', value: 'email'},
        {text: 'Perfil', value: 'role'},
        {text: 'CRM', value: 'role'},
        {text: 'Assinatura', value: 'role'},
        {text: 'Ações', value: 'actions', sortable: false, align: 'center'}
      ]
    }
  },

  computed: {
    ...mapState({
      users: (state) => state.users,
      company: (state) => state.company,
      user: (state) => state.user
    }),
    isAdmin () {
      return this.user && this.user.role === 'admin'
    }
  },

  mounted () {
    this.loadUsers()
  },

  watch: {
    dialog (val) {
      if (!val) {
        this.loadUsers()
      }
    }
  },

  methods: {
    ...mapActions(['loadUsers']),
    editUser (user) {
      this.dialogUser = {...user, companiesStr: user.companies.join(', ')}
      this.dialog = true
    },
    newUser () {
      this.dialogUser = {
        company: this.company,
        companies: [this.company],
        companiesStr: this.company
      }
      this.dialog = true
    },
    async removeTOTP (item) {
      try {
        const result = await this.$swal.fire({
          title: 'Remover autenticação de dois fatores',
          text: 'Tem certeza que deseja remover a autenticação de dois fatores deste usuário?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, remover',
          cancelButtonText: 'Cancelar'
        })

        if (result.value) {
          await api.post('/removeTOTP', {
            userId: item.iuid
          })

          // Atualiza o item na lista
          item.totpEnabled = false

          this.$swal.fire(
            'Removido!',
            'A autenticação de dois fatores foi removida com sucesso.',
            'success'
          )
        }
      } catch (error) {
        console.error('Erro ao remover TOTP:', error)
        this.$swal.fire({
          title: 'Erro',
          text: 'Não foi possível remover a autenticação de dois fatores',
          icon: 'error'
        })
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Users.vue